import { render, staticRenderFns } from "./BaseFilterTabsContent.vue?vue&type=template&id=4609dd22&scoped=true"
import script from "./BaseFilterTabsContent.vue?vue&type=script&lang=js"
export * from "./BaseFilterTabsContent.vue?vue&type=script&lang=js"
import style0 from "./BaseFilterTabsContent.vue?vue&type=style&index=0&id=4609dd22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4609dd22",
  null
  
)

export default component.exports